<template>
  <!-- <el-select
    :transfer="transfer"
    :multiple="isMultiple"
    :placeholder="params.emptyText"
    v-model="realValue"
    @change="changeValue"
    :clearable="clearable"
    :filterable="filterable"
    :disabled="disabled" size="small">
    <el-option v-for="option in options" :value="option.value" :key="option.value" :label="option.displayName"></el-option>
  </el-select> -->
  <Select
    :transfer="transfer"
    :multiple="isMultiple"
    :placeholder="params.emptyText"
    v-model="realValue"
    @on-change="changeValue"
    :clearable="clearable"
    :filterable="filterable"
    :disabled="disabled">
    <Option v-for="option in options.filter(item=>item.value.indexOf('Zone') === -1)" :value="option.value" :key="option.value" :label="option.displayName"></Option>
  </Select>
</template>

<script>
  export default {
    name: 'ElStaticSelector',
    props: {
      dispatchName: '',
      params:{
        type: Object
      },
      value:{
        type: [String, Array]
      },
      clearable:{
        type: Boolean,
        default: true
      },
      filterable:{
        type: Boolean,
        default: false
      },
      disabled:{
        type: Boolean,
        default: false
      },
      autoLoad:{
        type: Boolean,
        default: true
      },
      isMultiple: {
        type: Boolean,
        default: false
      },
      transfer: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        realValue: this.value,
        loading: false,
        options: [],
        language: this.$i18n.locale,
      };
    },
    mounted(){
      this.loadData();
    },
    watch:{
      value(val){
        this.realValue = val;

        //20190528 bug:7348 原因：realValue中包含有options中不存在的value
        if (typeof(this.realValue) === 'object' ){
          // console.log('this.realValue befor',this.realValue)
          if (this.realValue && this.realValue.length >0 && this.options && this.options.length>0){
            for (let i in this.realValue){
              let idx=this.options.findIndex((value) => {
                return value.value === this.realValue[i]
              })
              if ( idx === -1 ){
                this.realValue.splice(i,1)
              }
            }
          }
          // console.log('this.realValue after',this.realValue)
        }
      },
      autoLoad(val) {
        if (val) {
          this.loadData()
        }
      },
      '$i18n.locale': {
        handler: function () {
          // this.loadData()
        },
        deep: true
      },

    },
    methods: {
      changeValue(value){
        this.$emit('input',value);
        this.$emit('selectChange',value);
      },
      resetValue(){
        if (this.value) {
          this.realValue = this.value;
        } else {
          this.realValue = '';
        }
      },
      loadData(remoteUrl){
        this.dispatchName = ''
        if (this.params.sellectorUser === 0){
          // 获取 价格计算目的区域下拉值
          this.dispatchName = 'queryPriceAreaByType'
          if (this.dispatchName && this.autoLoad ){
            this.loading = true;
            let type = 1
            let list = [];
            if (localStorage.getItem('queryPriceArea')) {
              let queryPriceArea = JSON.parse(localStorage.getItem('queryPriceArea'))
              if (queryPriceArea && queryPriceArea.length > 0){
                queryPriceArea.forEach((item)=>{
                  let displayN = ''
                  if(this.$i18n.locale === 'zh-CN'){
                    displayN = item.displayNameZh
                  }
                  if(this.$i18n.locale === 'en-US'){
                    displayN = item.displayNameEn
                  }
                  list.push({
                    value: item.value,
                    displayName: displayN
                  })
                })
              }
              this.options = list;
              this.loading = false;
            } else {
              this.$store.dispatch(this.dispatchName, { type }).then(() => {
                if (!JSON.parse(localStorage.getItem('queryPriceArea'))) {
                  list = []
                } else {
                  let queryPriceArea = JSON.parse(localStorage.getItem('queryPriceArea'))
                  if (queryPriceArea && queryPriceArea.length > 0){
                    queryPriceArea.forEach((item)=>{
                      let displayN = ''
                      if(this.$i18n.locale === 'zh-CN'){
                        displayN = item.displayNameZh
                      }
                      if(this.$i18n.locale === 'en-US'){
                        displayN = item.displayNameEn
                      }
                      list.push({
                        value: item.value,
                        displayName: displayN
                      })
                    })
                  }
                }
                this.options = list;
                this.loading = false;
              }).catch(error=>{
                this.loading = false;
                this.options = [];
                console.error(error);
              });
            }
          }
        } else {
          if (this.dispatchName && this.autoLoad ){
            this.loading = true;
            let list = [];
            this.$store
              .dispatch(this.dispatchName, { districtCode  })
              .then(data=> {
                if (data && data.success && data.selectorResult && data.selectorResult.length > 0){
                  data.selectorResult.forEach(item => {
                    if (item && item.value) {
                      list.push({
                        value: item.value,
                        displayName: item.displayName
                      })
                    }
                  });
                }
                //添加全部选择条件
                if (this.value === 'all') {
                  list.unshift({ displayName: this.$t('global.defaultOption'),value: 'all' });
                }
                this.options = list;
                this.loading = false;
              }).catch(error=>{
              this.loading = false;
              this.options = [];
              console.error(error);
            });
          } else {
            //添加全部选择条件
            if (this.value === 'all') {
              this.options.unshift({ displayName: this.$t('global.defaultOption'),value: 'all' });
            }
          }
        }

      }
    },
    updated(){
      if (this.params.selectIndex && this.options[this.params.selectIndex]) {
        this.realValue = this.options[this.params.selectIndex]['value'];
      }
      this.params.selectIndex = '';
    }
  };
</script>



// WEBPACK FOOTER //
// ElStaticSelector.vue?0a4214d9